import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

interface AddZonePromptProps {
  isVisible: boolean;
  zoneName: string;
  isCreating: boolean;
  onZoneNameChange: (value: string) => void;
  onConfirm: () => void;
  onCancel: () => void;
}

export const AddZonePrompt = ({
  isVisible,
  zoneName,
  isCreating,
  onZoneNameChange,
  onConfirm,
  onCancel,
}: AddZonePromptProps) => {
  if (!isVisible) return null;

  return (
    <div className="absolute top-20 left-2 z-30 border rounded-lg p-4 shadow-lg" style={{ backgroundColor: '#17221f' }}>
      <div className="flex flex-col gap-2">
        <Input
          type="text"
          placeholder="Enter zone name"
          value={zoneName}
          onChange={(e) => onZoneNameChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              onConfirm();
            } else if (e.key === 'Escape') {
              onCancel();
            }
          }}
          autoFocus
        />
        <div className="flex gap-2">
          <Button
            onClick={onConfirm}
            disabled={!zoneName.trim() || isCreating}
            size="sm"
          >
            {isCreating ? 'Creating...' : 'Create'}
          </Button>
          <Button
            onClick={onCancel}
            variant="outline"
            size="sm"
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};